module.exports = __webpack_public_path__ + "img/header1.eb2fc11b.png";